import React, { useState, useEffect } from "react";
import "./BollettaOnlinePage.scss";
import { useDispatch } from "react-redux";
import Hero from "../../common/Hero/Hero";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContarctListWrapper from "../../../components/pages/ContractsPage/ContractListWrapper/ContractListWrapper";
import { LIST_CONTRACTS_SMALL } from "../../../helpers/queries";
import { handlerErrors, formatContractStatus } from "../../../helpers/helpers";
import { hideLoading, showLoading } from "../../../reducers/app";
import { client } from "../../../App";
import EmailModal from "../../common/ConfirmEmailModal/EmailModal";
import NoResult from "../../../components/common/NoResult/NoResult";
import Modal from "../../common/Modal/Modal";

import {
  enableBills,
  disableBills,
  changeEmailBills,
} from "../../../components/pages/ContractsPage/helpers";

const BollettaOnlinePage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [contracts, setContracts] = useState([]);
  const [clickedRowIndex, setClickedRow] = useState(null);
  const [genericError, setGenericError] = useState(null);
  const [infoModal, setInfoModal] = useState({ active: false, type: null });
  const [active, setActive] = useState(false);
  const [enable, setEnable] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const listContracts = async () =>
    client().query({
      query: LIST_CONTRACTS_SMALL,
    });

  const columns = React.useMemo(
    () => [
      {
        Header: t("online.bills.table.contract"),
        accessor: "contratto",
        id: 1,
      },
      {
        Header: t("online.bills.table.status"),
        accessor: "stato_contratto",
        id: 2,
      },
      {
        Header: t("online.bills.table.billStatus"),
        accessor: "bolletta_online",
        id: 3,
      },
      {
        Header: t("online.bills.table.emailStatus"),
        accessor: "email_bolletta_online",
        id: 4,
      },
    ],
    [t]
  );

  const onlineStatusBillFormater = (isActive, id, email) => {
    return isActive ? (
      <p property={{ status: "active", id, email }}>
        {t("online.bills.table.active")}
      </p>
    ) : (
      <p property={{ status: "deactive", id, email }}>
        {t("online.bills.table.deactive")}
      </p>
    );
  };

    const onlineBillFormater = (isActive, id, email) => {
      if (isActive) {
        return (
          <button
            type="button"
            onClick={() => setInfoModal({ active: true, type: "DISABLE", id, email })}
            className="underline link-style"
          >
            {t("contract.deactivate.or.modify")}
          </button>
        );
      } else {
        return (
          <button
            type="button"
            onClick={() => setInfoModal({ active: true, type: "ENABLE", id, email })}
            className="underline link-style"
          >
            {t("contract.active")}
          </button>
        );
      }
    };
  const enableOnlineBillsDataLayer = () => { window.dataLayer.push({ "event": "pratica", "tipo": "BollettaOnline_attiva", "step": "invio_richiesta", "esito": "OK" }) };
  const enableOnlineBillsDataLayerKo = () => { window.dataLayer.push({ "event": "pratica", "tipo": "BollettaOnline_attiva", "step": "invio_richiesta", "esito": "KO" }) };
  const disableOnlineBillsDataLayer = () => { window.dataLayer.push({ "event": "pratica", "tipo": "BollettaOnline_disattiva", "step": "invio_richiesta", "esito": "OK" }) };
  const disableOnlineBillsDataLayerKo = () => { window.dataLayer.push({ "event": "pratica", "tipo": "BollettaOnline_disattiva", "step": "invio_richiesta", "esito": "KO" }) };

  const enableBillsHandler = (email) => {
    const contractId = infoModal.id;
    enableBills(
      contractId,
      email,
      dispatch,
      setGenericError,
      setInfoModal,
      setEnable,
      setRefresh,
      refresh,
      enableOnlineBillsDataLayer,
      enableOnlineBillsDataLayerKo,
    );
  };

  const disableBillsHandler = () => {
    const contractId = infoModal.id;
    disableBills(
      contractId,
      dispatch,
      setGenericError,
      setInfoModal,
      setEnable,
      setRefresh,
      refresh,
      disableOnlineBillsDataLayer,
      disableOnlineBillsDataLayerKo
    );
  };

  const changeEmailBillsHandler = (email) => {
    const contractId = infoModal.id;
    changeEmailBills(
      contractId,
      email,
      dispatch,
      setGenericError,
      setInfoModal,
      setRefresh,
      refresh
    );
  };

  useEffect(() => {
    dispatch(showLoading());
    listContracts()
      .then(({ data }) => {
        console.log(data, "datta");
        if (data.listContracts.pagination.totalElements) {
          const formated = data.listContracts.elements.map(
            ({
              puf: { street, streetNumber, city, province, postalCode },
              contractId,
              integraClientCode,
              integraContractCode,
              status: { code },
              serviceOnlineBill: { enabled, email },
            }) => {
              return {
                contractId: { contractId, status: { code } },
                contratto: `${integraClientCode} - ${integraContractCode} ${street} ${streetNumber} ${city} ${province} ${postalCode}`,
                stato_contratto: formatContractStatus(code),
                bolletta_online: onlineStatusBillFormater(
                  enabled,
                  contractId,
                  email
                ),
                email_bolletta_online: onlineBillFormater(
                  enabled,
                  contractId,
                  email
                ),
              };
            }
          );
          setContracts(formated);
          dispatch(hideLoading());
        } else {
          dispatch(hideLoading());
          setGenericError(t("contract.noContractFound"));
        }
      })
      .catch((err) => {
        handlerErrors(err, setGenericError, setGenericError);
      });
    // eslint-disable-next-line
  }, [refresh]);

  const orderColumns = ["test1", "test2", "test3"];

  const renderInfoModal = () => {
    const email = infoModal.email;
    switch (infoModal.type) {
      case "DISABLE": {
        return (
          <EmailModal
            email={email}
            title={t("email.modal.title")}
            emailTitle={t("email.modal.header")}
            emailPlaceholder={t("email.modal.placeholder")}
            btnText={t("email.modal.btnDeactivate")}
            btnConfirm={t("email.moda.btnConfirm")}
            isOpen={true}
            disable={disableBillsHandler}
            changeEmailBill={changeEmailBillsHandler}
            onClose={() => setInfoModal({ active: false, type: null })}
            to={"/"}
            desc={t("email.modal.deactivate.text")}
            info={"Attenzione! In caso di utilizzo di indirizzo pec si prega di verificare che sia abilitato a ricevere mail non certificate."}
          />
        );
      }

      case "ENABLE": {
        return (
          <EmailModal
            title={t("email.modal.title")}
            emailTitle={t("email.modal.header")}
            emailPlaceholder={t("email.modal.placeholder")}
            btnText={t("email.moda.btnConfirm")}
            isOpen={true}
            enable={enableBillsHandler}
            onClose={() => setInfoModal({ active: false, type: null })}
            to={"/"}
            // info={t("add_online_bills_popup")}
            info={""}
          />
        );
      }
      case "EDIT_EMAIL": {
        return (
          <EmailModal
            email={email}
            title={t("email.modal.title")}
            emailTitle={t("email.modal.header")}
            emailPlaceholder={t("email.modal.placeholder")}
            btnText={t("email.modal.btnModifyEmail")}
            btnConfirm={t("email.moda.btnConfirm")}
            isOpen={true}
            disableOblineBill={true}
            changeEmailBill={changeEmailBillsHandler}
            onClose={() => setInfoModal({ active: false, type: null })}
            to={"/"}
            // info={t("add_online_bills_popup")}
            info={""}
          />
        );
      }
      case "ERROR": {
        return (
          <Modal
            description={genericError}
            type="button"
            onFirstClick={() => setInfoModal({ active: false, type: null })}
            show={true}
            onClose={() => setInfoModal({ active: false, type: null })}
            linkTitle={t("common.hoCapito")}
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  const renderConfirmModal = () => {
    return (
      <Modal
        description={ enable ? t("confirm.online.bill.description") : t("confirm.online.bill.description.disable") }
        linkTitle={t("common.hoCapito")}
        type={"link"}
        to={"/online-bills"}
        onFirstClick={() => setActive(false)}
        icon={"gc-icon-functional-check-2-col"}
        show={true}
        onClose={() => setActive(false)}
      />
    );
  };

  return (
    <div className="BollettaOnlinePage" data-testid="BollettaOnlinePage">
      <Hero
        helpText={t("online.bills.info.title")}
        backTo={"/"}
        backToText={t("common.back.home")}
        title={t("bill.header")}
        description={
          <div>
            <p>{t("bill.title")}</p>
            <Link to={"/contracts/add"}>{t("bill.contract")}</Link>
          </div>
        }
      />
      {contracts.length > 0 ? (
        <ContarctListWrapper
          hideData={true}
          clickedRowIndex={clickedRowIndex}
          columns={columns}
          data={contracts}
          orderColumns={orderColumns}
          setClickedRow={setClickedRow}
          isDisablePage={false}
          disableContracts={(contracts) => console.log("contracts", contracts)}
          tableName={t("online.bills.tabele.title")}
          t={t}
          onlineBill={true}
          setInfoModal={setInfoModal}
        />
      ) : (
        <NoResult text={t("online.bills.noResults")} />
      )}

      {infoModal.active && renderInfoModal()}

      {active && renderConfirmModal()}
    </div>
  );
};

BollettaOnlinePage.propTypes = {};

export default BollettaOnlinePage;
